<template>
    <van-picker-group
        title="预约日期"
        :tabs="['选择日期', '选择时间']"
        next-step-text="下一步"
        @confirm="onDateConfirm"
        @cancel="onDateCancel"
    >
    </van-picker-group>
</template>

<script>
import { ref } from 'vue';
import { showToast } from 'vant';

export default {
    setup() {
        const currentDate = ref(['2022', '06', '01']);
        const currentTime = ref(['12', '00']);

        const onConfirm = () => {
            showToast(
                `${currentDate.value.join('/')} ${currentTime.value.join(':')}`,
            );
        };

        const onCancel = () => {
            showToast('cancel');
        };

        return {
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 5, 1),
            currentDate,
            currentTime,
            onConfirm,
            onCancel,
        };
    },
};
</script>
